// Helper function to process video accessibility for a container
function processVideoAccessibility(container, containerName) {
  const lsVideo = container.querySelector('#ls-video');
  
  if (lsVideo && !lsVideo.hasAttribute('aria-labelledby')) {
    lsVideo.setAttribute('aria-labelledby', 'ls-detail-caption');
    
    const lsDetailCaption = document.querySelector('.ls-detail-caption');
    if (lsDetailCaption) {
      lsDetailCaption.setAttribute('id', 'ls-detail-caption');
    }
  }
}

// Function to handle accessibility attributes
function handleLsVideoAccessibility() {
  const containers = [
    { selector: '#ls-slider-popup-container', name: '#ls-slider-popup-container' },
    { selector: '#ls-popup-container', name: '#ls-popup-container' }
  ];
  
  containers.forEach(({ selector, name }) => {
    const container = document.querySelector(selector);
    if (container) {
      processVideoAccessibility(container, name);
    }
  });
}

// Dynamically inject/remove the loading announcement text in the predictive-search
// live region. Static content already present in the DOM when a live region becomes
// visible is never announced by screen readers — only newly added content is.
(function () {
  function syncLoadingAnnouncement(el) {
    var announcement = el.querySelector('.js-loading-announcement');
    if (!el.hasAttribute('hidden')) {
      if (!announcement) {
        var span = document.createElement('span');
        span.className = 'visually-hidden js-loading-announcement';
        span.textContent = el.dataset.loadingText || 'Loading search results';
        el.appendChild(span);
      }
    } else if (announcement) {
      announcement.remove();
    }
  }

  function attachLoadingObserver(el) {
    if (el.dataset.loadingObserverAttached) return;
    el.dataset.loadingObserverAttached = 'true';
    new MutationObserver(function () {
      syncLoadingAnnouncement(el);
    }).observe(el, { attributes: true, attributeFilter: ['hidden'] });
  }

  function initLoadingAnnouncements() {
    document.querySelectorAll('.predictive-search__loading-state').forEach(attachLoadingObserver);
  }

  initLoadingAnnouncements();
  new MutationObserver(initLoadingAnnouncements).observe(document.body, { childList: true, subtree: true });
})();

// Watch for #ls-slider-popup-container
const lsSliderObserver = new MutationObserver((mutations) => {
  handleLsVideoAccessibility();
});

lsSliderObserver.observe(document.body, {
  childList: true,
  subtree: true
});

// Update Flickity page dots aria-labels from 'Page dot' to 'Slide', and set ARIA roles
function updateFlickityDotsAriaLabels() {
  const containers = document.querySelectorAll('.flickitylf-page-dots');
  containers.forEach((container) => {
    if (!container.hasAttribute('role')) {
      container.setAttribute('role', 'presentation');
    }
  });

  const dots = document.querySelectorAll('.flickitylf-page-dots .dot');
  dots.forEach((dot) => {
    if (!dot.hasAttribute('role')) {
      dot.setAttribute('role', 'button');
    }
    const ariaLabel = dot.getAttribute('aria-label');
    if (ariaLabel && ariaLabel.includes('Page dot')) {
      dot.setAttribute('aria-label', ariaLabel.replace('Page dot', 'Slide'));
    }
  });
}

// Run on page load
updateFlickityDotsAriaLabels();

// Watch for dynamically added dots
let flickityDotsUpdateScheduled = false;
const flickityDotsObserver = new MutationObserver(() => {
  if (flickityDotsUpdateScheduled) return;
  flickityDotsUpdateScheduled = true;
  requestAnimationFrame(() => {
    flickityDotsUpdateScheduled = false;
    updateFlickityDotsAriaLabels();
  });
});

flickityDotsObserver.observe(document.body, {
  childList: true,
  subtree: true
});

// Sync tabindex on focusable children whenever a carousel cell's aria-hidden changes.
// Flickity sets aria-hidden="true" on non-selected cells but leaves their focusable
// descendants keyboard-reachable, causing WCAG SC 1.3.1 / 4.1.2 violations.
(function () {
  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]';

  function syncCellFocusability(cell) {
    var hidden = cell.getAttribute('aria-hidden') === 'true';
    cell.querySelectorAll(FOCUSABLE).forEach(function (el) {
      if (hidden) {
        if (!el.hasAttribute('data-tabindex-saved')) {
          var orig = el.getAttribute('tabindex');
          el.setAttribute('data-tabindex-saved', orig !== null ? orig : '');
        }
        el.setAttribute('tabindex', '-1');
      } else if (el.hasAttribute('data-tabindex-saved')) {
        var saved = el.getAttribute('data-tabindex-saved');
        if (saved === '') {
          el.removeAttribute('tabindex');
        } else {
          el.setAttribute('tabindex', saved);
        }
        el.removeAttribute('data-tabindex-saved');
      }
    });
  }

  function attachCellObserver(cell) {
    if (cell.dataset.ariaHiddenGuard) return;
    cell.dataset.ariaHiddenGuard = 'true';
    syncCellFocusability(cell);
    new MutationObserver(function () {
      syncCellFocusability(cell);
    }).observe(cell, { attributes: true, attributeFilter: ['aria-hidden'] });
  }

  function attachToAllCells() {
    document.querySelectorAll('.carousel-cell').forEach(attachCellObserver);
  }

  attachToAllCells();

  new MutationObserver(attachToAllCells).observe(document.body, {
    childList: true,
    subtree: true,
  });
})();

// Add focus class to kt-image-item-box when kt-image-link is focused
function setupImageLinkFocus() {
  document.querySelectorAll('.kt-image-link, .kt-image-lightbox').forEach((link) => {
    if (link.dataset.focusListenerAdded) return;
    link.dataset.focusListenerAdded = 'true';
    
    link.addEventListener('focus', () => {
      const parent = link.closest('.kt-image-item-box');
      if (parent) parent.classList.add('has-focus-within');
    });
    
    link.addEventListener('blur', () => {
      const parent = link.closest('.kt-image-item-box');
      if (parent) parent.classList.remove('has-focus-within');
    });
  });
}

// Run on page load
setupImageLinkFocus();

// Watch for dynamically added links
const imageLinkObserver = new MutationObserver(() => {
  setupImageLinkFocus();
});

imageLinkObserver.observe(document.body, {
  childList: true,
  subtree: true
});

// Product-media Flickity gallery — complete the WAI-ARIA carousel slide pattern.
// The gallery container carries role="region"/aria-roledescription="carousel" and
// each cell carries role="group"/aria-roledescription="slide" from Liquid, but three
// things must be done at runtime because the visible slide set changes as the
// shopper switches variants:
//   1. Give each visible slide a "N of M" accessible name (M is variant-dependent).
//   2. Hide variant-filtered cells from assistive tech. Flickity's cellSelector
//      excludes .is-filtered cells from the track, so it never marks them
//      aria-hidden and they would otherwise be announced as extra slides.
//   3. Take the off-screen slides out of the page entirely once the carousel has
//      settled (see hideOffscreenSlides).
// We never touch aria-hidden on the real (non-filtered) slides — Flickity owns that
// so only the current slide is exposed — using a data marker to tell our own
// aria-hidden apart from Flickity's when a cell flips back to non-filtered.
(function () {
  var OFFSCREEN_CLASS = 'is-ada-offscreen';

  // Slides that are not on screen must be unreachable, not merely unannounced:
  // Flickity only sets aria-hidden, which still leaves a slide's focusable content
  // (a video play button, a model viewer) in the tab order. The class adds
  // visibility: hidden, which removes both.
  //
  // Timing matters. Flickity flips is-selected/aria-hidden when a slide is *chosen*,
  // while the outgoing slide is still animating out of view, so hiding on that
  // signal would make it vanish mid-flight (and dragging would pull in blank
  // space). So every cell is revealed as soon as the carousel starts moving and
  // only re-hidden on the "settle" event, when nothing is in motion.
  function hideOffscreenSlides(carousel) {
    if (!carousel.classList.contains('flickity-enabled')) return;

    carousel.querySelectorAll('.product__media-item').forEach(function (item) {
      item.classList.toggle(
        OFFSCREEN_CLASS,
        !item.classList.contains('is-selected')
      );
    });
  }

  function revealAllSlides(carousel) {
    carousel.querySelectorAll('.' + OFFSCREEN_CLASS).forEach(function (item) {
      item.classList.remove(OFFSCREEN_CLASS);
    });
  }

  function watchSlideVisibility(carousel) {
    if (carousel.dataset.adaSlideVisibility) return;
    carousel.dataset.adaSlideVisibility = 'true';

    // Fires on init and again after a variant change reloads the carousel.
    carousel.addEventListener('flickity:ready', function () {
      hideOffscreenSlides(carousel);
    });
    carousel.addEventListener('flickity:slide-settled', function () {
      hideOffscreenSlides(carousel);
    });
    carousel.addEventListener('flickity:slide-changed', function () {
      revealAllSlides(carousel);
    });
    // A drag moves the cells before it crosses the threshold that changes slide,
    // so uncover them as soon as the pointer goes down.
    carousel.addEventListener('pointerdown', function () {
      revealAllSlides(carousel);
    });

    // Flickity may already be initialised by the time this script runs, in which
    // case its "ready" event has been and gone.
    hideOffscreenSlides(carousel);
  }

  function moveTabStopToSelectedSlide(carousel) {
    carousel.removeAttribute('tabindex');
    carousel.querySelectorAll('.product__media-item').forEach(function (item) {
      var wantTabIndex = item.classList.contains('is-selected') ? 0 : -1;
      if (item.tabIndex !== wantTabIndex) item.tabIndex = wantTabIndex;
    });
  }

  function enhanceGallery(carousel) {
    watchSlideVisibility(carousel);
    moveTabStopToSelectedSlide(carousel);

    var items = carousel.querySelectorAll('.product__media-item');
    var visible = [];

    items.forEach(function (item) {
      if (item.classList.contains('is-filtered')) {
        if (item.getAttribute('aria-hidden') !== 'true') {
          item.setAttribute('aria-hidden', 'true');
        }
        item.setAttribute('data-ada-filtered-hidden', 'true');
      } else {
        // Only clear aria-hidden that we set for filtering; leave Flickity's alone.
        if (item.hasAttribute('data-ada-filtered-hidden')) {
          item.removeAttribute('aria-hidden');
          item.removeAttribute('data-ada-filtered-hidden');
        }
        visible.push(item);
      }
    });

    var total = visible.length;

    visible.forEach(function (item, index) {
      var labelId = item.id ? item.id + '-slide-label' : '';
      var label = item.querySelector(':scope > .product__media-slide-label');

      if (!label) {
        label = document.createElement('span');
        label.className = 'visually-hidden product__media-slide-label';
        item.appendChild(label);
      }

      var template =
        (window.themeVariables &&
          window.themeVariables.strings &&
          window.themeVariables.strings.slideCount) ||
        '@current@ of @total@';
      var text = template
        .replace('@current@', index + 1)
        .replace('@total@', total);
      if (label.textContent !== text) {
        label.textContent = text;
      }
      if (labelId && label.id !== labelId) {
        label.id = labelId;
      }
      if (labelId && item.getAttribute('aria-labelledby') !== labelId) {
        item.setAttribute('aria-labelledby', labelId);
      }
    });
  }

  function enhanceAllGalleries() {
    document
      .querySelectorAll('flickity-carousel.product__media-list')
      .forEach(enhanceGallery);
  }

  enhanceAllGalleries();

  // Flickity moves cells into its track and toggles is-selected/aria-hidden after
  // init, and variant selection toggles is-filtered — re-run on any of those,
  // debounced to once per frame. Idempotent writes let the observer settle quietly.
  // 'tabindex' is included because Flickity sets its own tabindex="0" on the
  // carousel asynchronously during init - if that happens after the last
  // class/aria-hidden mutation this observer caught, nothing else would ever
  // re-trigger moveTabStopToSelectedSlide() to strip it back off.
  var galleryUpdateScheduled = false;
  new MutationObserver(function () {
    if (galleryUpdateScheduled) return;
    galleryUpdateScheduled = true;
    requestAnimationFrame(function () {
      galleryUpdateScheduled = false;
      enhanceAllGalleries();
    });
  }).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'aria-hidden', 'tabindex']
  });
})();

// Dialog trigger (ARIA dialog pattern) — the DashSocial/Lookfy "Learn More" buttons
// open a modal media/product lightbox, so each trigger must advertise that with
// aria-haspopup="dialog". The buttons are injected and re-rendered by the app, so we
// set it on load and whenever new cards appear.
(function () {
  function markDialogTriggers() {
    document.querySelectorAll('.media-action').forEach(function (btn) {
      if (btn.getAttribute('aria-haspopup') !== 'dialog') {
        btn.setAttribute('aria-haspopup', 'dialog');
      }
    });
  }

  markDialogTriggers();

  var dialogTriggerScheduled = false;
  new MutationObserver(function () {
    if (dialogTriggerScheduled) return;
    dialogTriggerScheduled = true;
    requestAnimationFrame(function () {
      dialogTriggerScheduled = false;
      markDialogTriggers();
    });
  }).observe(document.body, { childList: true, subtree: true });
})();

// WCAG 1.4.13 (Content on Hover or Focus) — the CSS [data-tooltip] utility (e.g.
// color-swatch names) shows a tooltip on hover/focus. Escape must dismiss it
// without requiring the pointer or focus to move. We flag the active element with
// data-tooltip-dismissed (CSS then hides its ::before/::after); the flag clears
// when the pointer leaves or focus exits, so hovering/focusing again shows it.
(function () {
  function armClear(el) {
    if (el.dataset.tooltipDismissArmed) return;
    el.dataset.tooltipDismissArmed = 'true';

    function clear() {
      el.removeAttribute('data-tooltip-dismissed');
    }
    el.addEventListener('mouseleave', clear);
    el.addEventListener('focusout', function (e) {
      if (!el.contains(e.relatedTarget)) clear();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc' && e.keyCode !== 27) return;

    var targets = [];

    // Elements currently under the pointer (hover-shown tooltip).
    try {
      document.querySelectorAll('[data-tooltip]:hover').forEach(function (el) {
        if (targets.indexOf(el) === -1) targets.push(el);
      });
    } catch (err) {}

    // Element holding keyboard focus (focus-within-shown tooltip).
    var active = document.activeElement;
    var focused = active && active.closest ? active.closest('[data-tooltip]') : null;
    if (focused && targets.indexOf(focused) === -1) targets.push(focused);

    if (!targets.length) return;

    targets.forEach(function (el) {
      el.setAttribute('data-tooltip-dismissed', '');
      armClear(el);
    });
  });
})();




// Carousel accessibility (multi-column reviews / collections / products, gallery, product lists).
// Keeps the carousel semantics in one place so every scroll-snap carousel gets the same treatment:
//  - container: role="region" + aria-roledescription="carousel" + an accessible name
//  - the slides' parent is a list, and each slide stays a list item (a real <li>, or role="listitem" on a
//    custom element) carrying aria-roledescription="slide", an id and aria-labelledby pointing at a
//    visually-hidden "X of Y" text. Slides never get role="group".
//  - slides that are not currently shown are removed from the accessibility tree (aria-hidden) and from the
//    tab order (tabindex="-1" on their focusable descendants) so only what is visible is read.
// The semantics only apply while the carousel is actually scrollable (prev/next shown); otherwise whatever this
// script added is removed again.
(function () {
  var CONFIGS = [
    { root: "multi-column", list: ".scrollable-list" },
    { root: "gallery-list", list: ".gallery__list" },
    { root: "product-list", list: ".product-list__inner" }
  ];
  var FOCUSABLE = 'a[href], button, input, select, textarea, summary, [tabindex]:not([tabindex="-1"]), [contenteditable="true"]';
  var uid = 0;
  var observed = new WeakSet();
  var resizeObserver = "ResizeObserver" in window ? new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      refresh(entry.target);
    });
  }) : null;

  function strings() {
    return (window.themeVariables && window.themeVariables.strings) || {};
  }

  function added(el) {
    return (el.getAttribute("data-carousel-added") || "").split(" ").filter(Boolean);
  }

  // Sets an attribute and remembers that this script added it, so it can be undone later
  function setAdded(el, name, value) {
    if (el.getAttribute(name) === value) return;
    var list = added(el);
    if (!el.hasAttribute(name) && list.indexOf(name) === -1) list.push(name);
    el.setAttribute(name, value);
    el.setAttribute("data-carousel-added", list.join(" "));
  }

  function removeAdded(el) {
    added(el).forEach(function (name) {
      el.removeAttribute(name);
    });
    el.removeAttribute("data-carousel-added");
  }

  function findScroller(list, root) {
    var el = list;
    while (el && el !== root.parentElement) {
      if (el.scrollWidth > el.clientWidth + 1 && /(auto|scroll)/.test(getComputedStyle(el).overflowX)) return el;
      el = el.parentElement;
    }
    return null;
  }

  function isCarousel(root, list) {
    if (root.hasAttribute("stack")) return false;
    var nav = root.querySelector("prev-next-buttons");
    if (!nav || getComputedStyle(nav).display === "none") return false;
    return !!findScroller(list, root);
  }

  // A div with an explicit role="list" (the block based multi-column carousels, where content_for "blocks"
  // wraps each block in a <div>) keeps list items for its children whether or not it is currently a carousel
  function keepListItems(list) {
    if (/^(UL|OL)$/.test(list.tagName) || list.getAttribute("role") !== "list") return;
    Array.prototype.forEach.call(list.children, function (child) {
      if (/^(SCRIPT|STYLE|TEMPLATE)$/.test(child.tagName)) return;
      var role = child.getAttribute("role");
      if (!role || role === "group") child.setAttribute("role", "listitem");
    });
  }

  function nameCarousel(root) {
    if (root.hasAttribute("aria-label") || root.hasAttribute("aria-labelledby")) return;
    var scope = root.closest(".shopify-section") || document;
    var heading = null;
    scope.querySelectorAll('[id*="heading"]').forEach(function (candidate) {
      if (candidate.compareDocumentPosition(root) & Node.DOCUMENT_POSITION_FOLLOWING) heading = candidate;
    });
    if (heading && heading.textContent.trim()) {
      setAdded(root, "aria-labelledby", heading.id);
    } else {
      setAdded(root, "aria-label", strings().carousel || "Carousel");
    }
  }

  function setSlideHidden(slide, hidden) {
    if (hidden) {
      if (slide.contains(document.activeElement)) return;
      slide.setAttribute("aria-hidden", "true");
      slide.querySelectorAll(FOCUSABLE).forEach(function (el) {
        if (el.hasAttribute("data-carousel-tabindex")) return;
        el.setAttribute("data-carousel-tabindex", el.hasAttribute("tabindex") ? el.getAttribute("tabindex") : "");
        el.setAttribute("tabindex", "-1");
      });
    } else {
      slide.removeAttribute("aria-hidden");
      slide.querySelectorAll("[data-carousel-tabindex]").forEach(function (el) {
        var original = el.getAttribute("data-carousel-tabindex");
        if (original === "") el.removeAttribute("tabindex");
        else el.setAttribute("tabindex", original);
        el.removeAttribute("data-carousel-tabindex");
      });
    }
  }

  function updateVisibility(root) {
    var state = root._carousel;
    if (!state || !state.active) return;
    var slides = state.slides();
    var scrollerRect = state.scroller.getBoundingClientRect();
    var visibility = slides.map(function (slide) {
      var rect = slide.getBoundingClientRect();
      var overlap = Math.min(rect.right, scrollerRect.right) - Math.max(rect.left, scrollerRect.left);
      return rect.width > 0 && overlap >= Math.min(rect.width, scrollerRect.width) * 0.5;
    });
    // Nothing measurable yet (hidden, not laid out): leave everything exposed rather than hide it all
    var anyVisible = visibility.some(Boolean);
    slides.forEach(function (slide, index) {
      setSlideHidden(slide, anyVisible && !visibility[index]);
    });
  }

  function onScroll(root) {
    var state = root._carousel;
    if (state.frame) return;
    state.frame = requestAnimationFrame(function () {
      state.frame = null;
      updateVisibility(root);
    });
  }

  function deactivate(root, list) {
    var state = root._carousel;
    if (state && state.scroller && state.onScroll) state.scroller.removeEventListener("scroll", state.onScroll);
    list.querySelectorAll("[data-carousel-added]").forEach(function (el) {
      el.querySelectorAll(":scope > [data-carousel-position]").forEach(function (span) {
        span.remove();
      });
      setSlideHidden(el, false);
      removeAdded(el);
    });
    removeAdded(root);
    removeAdded(list);
    root._carousel = { active: false };
  }

  function activate(root, list) {
    var state = root._carousel;
    var scroller = findScroller(list, root);
    var slidesOf = function () {
      return Array.prototype.filter.call(list.children, function (el) {
        return !/^(SCRIPT|STYLE|TEMPLATE)$/.test(el.tagName);
      });
    };

    if (!root.hasAttribute("role")) setAdded(root, "role", "region");
    if (!root.hasAttribute("aria-roledescription")) setAdded(root, "aria-roledescription", "carousel");
    nameCarousel(root);
    if (!/^(UL|OL)$/.test(list.tagName) && !list.hasAttribute("role")) setAdded(list, "role", "list");

    var slides = slidesOf();
    var total = slides.length;
    slides.forEach(function (slide, index) {
      var isLi = slide.tagName === "LI";
      var role = slide.getAttribute("role");
      if (isLi && role) {
        // A role on the <li> replaces its list item role (and leaves the list with non-list-item children)
        slide.removeAttribute("role");
      } else if (!isLi && !role) {
        setAdded(slide, "role", "listitem");
      } else if (!isLi && role === "group") {
        slide.setAttribute("role", "listitem");
      }
      if (/^\d+ of \d+$/.test(slide.getAttribute("aria-label") || "")) slide.removeAttribute("aria-label");

      if (!slide.id) setAdded(slide, "id", "carousel-slide-" + ++uid);
      if (slide.getAttribute("aria-roledescription") !== "slide") setAdded(slide, "aria-roledescription", "slide");

      var position = (strings().slidePosition || "@current@ of @total@").replace("@current@", index + 1).replace("@total@", total);
      var label = slide.querySelector(":scope > [data-carousel-position]");
      if (!label && !slide.hasAttribute("aria-labelledby")) {
        label = document.createElement("span");
        label.className = "visually-hidden";
        label.id = slide.id + "-label";
        label.setAttribute("data-carousel-position", "");
        slide.insertBefore(label, slide.firstChild);
        setAdded(slide, "aria-labelledby", label.id);
      }
      if (label) label.textContent = position;
    });

    if (state && state.scroller !== scroller && state.scroller && state.onScroll) {
      state.scroller.removeEventListener("scroll", state.onScroll);
    }
    if (!state || !state.active || state.scroller !== scroller) {
      var handler = function () {
        onScroll(root);
      };
      scroller.addEventListener("scroll", handler, { passive: true });
      root._carousel = { active: true, scroller: scroller, onScroll: handler, slides: slidesOf, frame: null };
    } else {
      state.slides = slidesOf;
    }
    updateVisibility(root);
  }

  function refresh(target) {
    CONFIGS.forEach(function (config) {
      var roots = [];
      if (!target || target === document) {
        roots = Array.prototype.slice.call(document.querySelectorAll(config.root));
      } else if (target.matches && target.matches(config.root)) {
        roots = [target];
      } else if (target.querySelectorAll) {
        roots = Array.prototype.slice.call(target.querySelectorAll(config.root));
      }

      roots.forEach(function (root) {
        var list = root.querySelector(config.list);
        if (!list) return;

        if (resizeObserver && !observed.has(root)) {
          observed.add(root);
          resizeObserver.observe(root);
        }

        keepListItems(list);
        if (isCarousel(root, list)) activate(root, list);
        else if (root._carousel && root._carousel.active) deactivate(root, list);
      });
    });
  }

  window.starkCarouselRefresh = refresh;

  var resizeTimer = null;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      refresh();
    }, 150);
  });
  document.addEventListener("shopify:section:load", function (event) {
    refresh(event.target);
  });
  window.addEventListener("load", function () {
    refresh();
  });
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      refresh();
    });
  } else {
    refresh();
  }
})();

// Lists whose items are Shopify block wrappers (content_for "blocks" wraps every block in
// <div class="shopify-block">), so the wrappers have to carry the list-item role.
(function () {
  function markBlockLists(scope) {
    (scope || document).querySelectorAll("[data-block-list]").forEach(function (list) {
      Array.prototype.forEach.call(list.children, function (child) {
        if (child.classList.contains("shopify-block") && !child.hasAttribute("role")) {
          child.setAttribute("role", "listitem");
        }
      });
    });
  }

  document.addEventListener("shopify:section:load", function (event) {
    markBlockLists(event.target);
  });
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      markBlockLists();
    });
  } else {
    markBlockLists();
  }
})();
